export default {
  listPage: {
    url: '/ec-pc-api/boom/listPage',
    type: 'post'
  }
}